import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface UpdateAddressPayload {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressType: string;
  latitude: string;
  longitude: string;
  pamCode: string;
}

export interface UpdateAddressApiError extends Error {
  status?: number;
  responseData?: any;
}

export async function updateAddressAsync(
  addressId: number | string,
  payload: UpdateAddressPayload,
  token: string,
  t: (key: string) => string
): Promise<any> {
  if (!navigator.onLine) {
    toast.error(t("internetConnection"), {
      toastId: "offline-error",
    });

    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/UpdateAddressAsync?addressId=${addressId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    let responseData: any = null;

    try {
      responseData = await response.json();
    } catch {
      responseData = null;
    }

    if (!response.ok) {
      const error: UpdateAddressApiError = new Error(
        responseData?.message || "Failed to update address"
      );

      error.status = response.status;
      error.responseData = responseData;

      throw error;
    }

    return responseData;
  } catch (error) {
    throw error;
  }
}